import { get, patch } from '../../utils/http';

export const updateProjectPayroll = ({ accountId, branchId, projectId, wages }) =>
  patch(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/payroll`, { ...wages });

export const fetchProjectPayroll = ({
  accountId,
  branchId,
  projectId,
  employeeIds,
  client,
  asClient,
  mode,
  withoutOnCost,
  useFreshData = false
}) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/payroll`, {
    employeeIds,
    options: { client, asClient, mode, withoutOnCost },
    useFreshData
  });

export const fetchProjectPayrollFields = ({ accountId, branchId, projectId, asClient = true }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/payroll/fields`, { asClient });

export const fetchProjectFinancials = ({ accountId, branchId, projectId, mode, withRevenue, from, to }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/payroll/financials`, {
    mode,
    withRevenue,
    from,
    to
  });

export const fetchProjectPosRevenue = ({ accountId, branchId, projectId }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/pos-revenue`);
